import { PosthogClientManager } from "./PosthogClientManager";

export const posthogClientManager = PosthogClientManager.instance();
